module.exports = __webpack_public_path__ + "img/ZB52_14.3f21c3c4.jpg";